import * as Yup from "yup";
import { validateIranianNationalId } from "../reports/userValidationSchema";

const numericOnly = /^\d+$/;

const attendeeSchema = Yup.object().shape({
  name: Yup.string().required("نام الزامی است."),
  mobile: Yup.string()
    .required("شماره تلفن الزامی است.")
    .matches(numericOnly, "تنها باید شامل اعداد باشد.")
    .min(11, "شماره تلفن باید حداقل 11 رقم باشد."),
  national_code: Yup.string()
    .trim("کد ملی نباید فقط از فاصله تشکیل شده باشد")
    .matches(/^[0-9]+$/, " لطفا فقط عدد وارد کنید")
    .matches(/^\d{10}$/, "کد ملی باید دقیقاً 10 رقم باشد")
    .test("iran-national-id", "کد ملی معتبر نیست", (value) =>
      validateIranianNationalId(value || "")
    )
    .required("فیلد را پر کنید"),

  male: Yup.boolean().required("جنسیت الزامی است."),
});

export const TicketInPersonValidationSchema = Yup.object().shape({
  matchId: Yup.string().required("الزامی است"),
  profilePlatformId: Yup.string().required("الزامی است"),
  attendees: Yup.lazy((val) =>
    Array.isArray(val)
      ? Yup.array().of(attendeeSchema).min(1, "حداقل یک هوادار باید اضافه شود.")
      : Yup.string().required("اضافه کردن هوادار الزامی است")
  ),
});
